import React, { useState } from 'react'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { FileZipOutlined } from '@ant-design/icons'
import styles from './IntegrationPurchasesZipDownloadButton.module.scss'
import { integrationPurchasesSelector, integrationStaticsSelector } from 'src/features'
import { exportPdfZip, getActualDateFormated, getIntegrationPurchaseBuyerData } from 'src/core/helpers'

const IntegrationPurchasesZipDownloadButton: React.FC = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const { data: { integration_code } } = useAppSelector(integrationStaticsSelector)
  const { data: integrationPurchases } = useAppSelector(integrationPurchasesSelector)

  const certificates: { name: string, url: string }[] = integrationPurchases.map(purchase => {
    return { url: purchase.certificate_url, name: getIntegrationPurchaseBuyerData(purchase) }
  })

  const handleDownload = async () => {
    setIsLoading(true)
    const fileName = `${integration_code?.toLowerCase()}_${getActualDateFormated()}`
    await exportPdfZip(fileName, certificates)
    setIsLoading(false)
  }

  return <Tooltip title={t('general.DownloadAll')} color='blue'>
    <Button
      type='dashed'
      shape='circle'
      loading={isLoading}
      onClick={handleDownload}
      className={styles.button}
      icon={<FileZipOutlined />}
    />
  </Tooltip>

}

export default IntegrationPurchasesZipDownloadButton
